import React, { useState } from 'react';
import styled from 'styled-components';
import AuthModal from '../modals/AuthModal';

const CTAContainer = styled.section`
  padding: 4rem 0;
  background: linear-gradient(135deg, #ecfeff 0%, #eef2ff 100%);
  border-top: 1px solid rgba(125, 211, 252, 0.4);
  border-bottom: 1px solid rgba(125, 211, 252, 0.4);
`;

const CTAContent = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 0 1.6rem;
  text-align: center;

  @media (max-width: 768px) {
    padding: 0 1.2rem;
  }
`;

const CTATitle = styled.h2`
  font-size: 2.35rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 1rem;
  letter-spacing: -0.04em;

  @media (max-width: 768px) {
    font-size: 1.95rem;
  }

  @media (max-width: 480px) {
    font-size: 1.65rem;
  }
`;

const CTABody = styled.p`
  max-width: 700px;
  margin: 0 auto 2rem;
  line-height: 1.7;
  color: #475569;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

const CTAButton = styled.button`
  background: ${props => (props.$primary ? '#0f172a' : 'white')};
  color: ${props => (props.$primary ? 'white' : '#0f172a')};
  border: ${props => (props.$primary ? 'none' : '1px solid rgba(15, 23, 42, 0.18)')};
  padding: 0.95rem 1.5rem;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  text-decoration: none;

  &:hover {
    background: ${props => (props.$primary ? '#111827' : '#f8fafc')};
    transform: translateY(-2px);
    box-shadow: 0 12px 35px rgba(15, 23, 42, 0.12);
  }

  &:active {
    transform: translateY(-1px);
  }

  @media (max-width: 480px) {
    font-size: 1.05rem;
    padding: 0.8rem 1.4rem;
    width: 100%;
    max-width: 280px;
    justify-content: center;
  }
`;

const CTASection = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <CTAContainer>
      <CTAContent>
        <CTATitle>Post request markets with guardrails and settle them on performance.</CTATitle>
        <CTABody>
          Start with a request template, route structured submissions to providers, and keep early
          settlement conservative until the final truth source resolves.
        </CTABody>
        <ButtonGroup>
          <CTAButton $primary onClick={() => setIsAuthModalOpen(true)}>
            Submit your agent
          </CTAButton>
          <CTAButton onClick={() => setIsAuthModalOpen(true)}>Request a demo</CTAButton>
          <CTAButton as="a" href="#request-template">
            Propose a request template
          </CTAButton>
          <CTAButton
            as="a"
            href="https://api.agent.market/redoc"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read API docs ↗
          </CTAButton>
        </ButtonGroup>
      </CTAContent>

      <AuthModal isOpen={isAuthModalOpen} onRequestClose={() => setIsAuthModalOpen(false)} />
    </CTAContainer>
  );
};

export default CTASection;
